import { parseJwt } from 'src/core/services/jwt';
import { AUTH_TOKEN_KEYS } from 'src/constants/authToken';
import { isPmRegularOrHigher } from 'src/constants/userSetting';

/** Same policy as the credential API (PmRegularOrHigher). Read from the token so it is right on the first render. */
export const canManageUtilityCredentials = () => {
  var _parseJwt;
  return isPmRegularOrHigher((_parseJwt = parseJwt(localStorage.getItem(AUTH_TOKEN_KEYS.accessToken))) === null || _parseJwt === void 0 ? void 0 : _parseJwt['custom:role']);
};